document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-mega-trigger]');
  const menu = document.querySelector('[data-mega-menu]');
  const mobileMenuToggle = event.target.closest('[data-mobile-menu-toggle]');
  const mobileMenuClose = event.target.closest('[data-mobile-menu-close]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const searchToggle = event.target.closest('[data-search-toggle]');
  const searchClose = event.target.closest('[data-search-close]');
  const searchDrawer = document.querySelector('[data-search-drawer]');
  const cartOpen = event.target.closest('[data-cart-drawer-open]');
  const cartClose = event.target.closest('[data-cart-drawer-close]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const collectionFilterOpen = event.target.closest('[data-collection-filter-open]');
  const collectionFilterClose = event.target.closest('[data-collection-filter-close]');
  const collectionFilterDrawer = document.querySelector('[data-collection-filter-drawer]');
  const navDropdownToggle = event.target.closest('[data-nav-dropdown-toggle]');
  const feedMediaControl = event.target.closest('[data-feed-media-prev], [data-feed-media-next]');

  if (feedMediaControl) {
    event.preventDefault();
    stepHomeFeedCardMedia(feedMediaControl);
    return;
  }

  if (navDropdownToggle) {
    const dropdown = navDropdownToggle.closest('[data-nav-dropdown]');
    const open = dropdown && !dropdown.classList.contains('is-open');

    document.querySelectorAll('[data-nav-dropdown].is-open').forEach((item) => {
      if (item !== dropdown) {
        item.classList.remove('is-open');
        const toggle = item.querySelector('[data-nav-dropdown-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });

    if (dropdown) {
      dropdown.classList.toggle('is-open', open);
      navDropdownToggle.setAttribute('aria-expanded', String(open));
    }
    return;
  }

  if (mobileMenuToggle && mobileMenu) {
    event.preventDefault();
    const open = !mobileMenu.classList.contains('is-open');
    mobileMenu.classList.toggle('is-open', open);
    mobileMenu.setAttribute('aria-hidden', String(!open));
    mobileMenuToggle.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('mobile-menu-open', open);
    if (open && menu) {
      menu.classList.remove('is-open');
      document.querySelectorAll('[data-mega-trigger][aria-expanded="true"]').forEach((activeTrigger) => {
        activeTrigger.setAttribute('aria-expanded', 'false');
      });
    }
    return;
  }

  if (mobileMenuClose && mobileMenu) {
    closeMobileMenu();
    return;
  }

  if (cartOpen && cartDrawer) {
    event.preventDefault();
    closeMobileMenu();
    openCartDrawer();
    return;
  }

  if (collectionFilterOpen && collectionFilterDrawer) {
    event.preventDefault();
    openCollectionFilters(collectionFilterDrawer, collectionFilterOpen);
    return;
  }

  if (collectionFilterClose && collectionFilterDrawer) {
    closeCollectionFilters(collectionFilterDrawer);
    return;
  }

  const collectionViewButton = event.target.closest('[data-collection-view]');
  if (collectionViewButton) {
    setCollectionView(collectionViewButton.dataset.collectionView, { load: true });
    return;
  }

  if (cartClose && cartDrawer) {
    closeCartDrawer();
    return;
  }

  const cartRemove = event.target.closest('[data-cart-remove]');
  if (cartRemove && window.fetch) {
    event.preventDefault();
    removeCartLine(cartRemove);
    return;
  }

  const relatedControl = event.target.closest('[data-product-related-prev], [data-product-related-next]');
  if (relatedControl) {
    const section = relatedControl.closest('.product-related-feed');
    const carousel = section && section.querySelector('[data-product-related-carousel]');
    const firstSlide = carousel && carousel.querySelector('.product-related-feed__slide');

    if (carousel && firstSlide) {
      const gap = parseFloat(window.getComputedStyle(carousel).columnGap) || 0;
      const direction = relatedControl.matches('[data-product-related-prev]') ? -1 : 1;
      carousel.scrollBy({ left: direction * (firstSlide.offsetWidth + gap), behavior: 'smooth' });
    }
    return;
  }

  const mediaThumb = event.target.closest('[data-product-media-thumb]');
  if (mediaThumb) {
    const gallery = mediaThumb.closest('.product-gallery');
    const targetId = mediaThumb.dataset.targetMedia;
    const targetSlide = targetId ? document.getElementById(targetId) : null;

    if (gallery && targetSlide) {
      gallery.querySelectorAll('[data-product-media-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb === mediaThumb);
      });

      gallery.querySelectorAll('[data-product-media-slide]').forEach((slide) => {
        const active = slide === targetSlide;
        slide.classList.toggle('product-gallery__slide--active', active);
        if (active) {
          slide.hidden = false;
        } else {
          window.setTimeout(() => {
            if (!slide.classList.contains('product-gallery__slide--active')) slide.hidden = true;
          }, 420);
        }
      });
    }
    return;
  }

  const quantityStep = event.target.closest('[data-quantity-step]');
  if (quantityStep) {
    const stepper = quantityStep.closest('[data-quantity-stepper]');
    const input = stepper && stepper.querySelector('input[type="number"]');
    if (input) {
      const step = parseInt(quantityStep.dataset.quantityStep, 10) || 0;
      const min = parseInt(input.getAttribute('min'), 10) || 1;
      const current = parseInt(input.value, 10) || min;
      input.value = Math.max(min, current + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return;
  }

  if (trigger && menu) {
    event.preventDefault();
    const open = menu.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', String(open));
    return;
  }

  if (searchToggle && searchDrawer) {
    closeMobileMenu();
    const open = searchDrawer.classList.toggle('is-open');
    searchToggle.setAttribute('aria-expanded', String(open));
    if (open) {
      const input = searchDrawer.querySelector('[data-predictive-search-input]');
      if (input) window.setTimeout(() => input.focus(), 50);
    }
    return;
  }

  if (searchClose && searchDrawer) {
    searchDrawer.classList.remove('is-open');
    const activeToggle = document.querySelector('[data-search-toggle]');
    if (activeToggle) activeToggle.setAttribute('aria-expanded', 'false');
    return;
  }

  if (menu && !event.target.closest('[data-mega-menu]') && !event.target.closest('[data-mega-trigger]') && !event.target.closest('[data-mega-trigger-item]')) {
    menu.classList.remove('is-open');
    const activeTrigger = document.querySelector('[data-mega-trigger][aria-expanded="true"]');
    if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'false');
  }

  if (!event.target.closest('[data-nav-dropdown]')) {
    document.querySelectorAll('[data-nav-dropdown].is-open').forEach((item) => {
      item.classList.remove('is-open');
      const toggle = item.querySelector('[data-nav-dropdown-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  if (searchDrawer && !event.target.closest('[data-search-drawer]') && !event.target.closest('[data-search-toggle]')) {
    searchDrawer.classList.remove('is-open');
    const activeToggle = document.querySelector('[data-search-toggle]');
    if (activeToggle) activeToggle.setAttribute('aria-expanded', 'false');
  }

  if (mobileMenu && !event.target.closest('[data-mobile-menu]') && !event.target.closest('[data-mobile-menu-toggle]')) {
    closeMobileMenu();
  }

  document.querySelectorAll('[data-collection-sort][open]').forEach((sortMenu) => {
    if (!event.target.closest('[data-collection-sort]')) sortMenu.removeAttribute('open');
  });
});

document.addEventListener('DOMContentLoaded', () => {
  initHeaderAnnouncementSliders();
  initRandomHomeProductFeeds();
  redirectLegacyVendorFilter();
  const collectionParams = new URLSearchParams(window.location.search);
  const urlCollectionView = collectionParams.get('view');
  const savedCollectionView = window.localStorage && window.localStorage.getItem('closerCollectionView');
  const initialCollectionView = ['3', '4', '5'].includes(urlCollectionView) ? urlCollectionView : (savedCollectionView || '3');
  setCollectionView(initialCollectionView, {
    persist: false,
    load: !urlCollectionView && savedCollectionView === '5'
  });
  updateCollectionVendorTitle();
  syncCollectionFilterInputsFromUrl();
  updatePriceRangeOutputs();
  applyCollectionOptionFilters();
  updateCollectionFilterApplyText();
});

document.addEventListener('shopify:section:load', (event) => {
  initHeaderAnnouncementSliders(event.target);
  initRandomHomeProductFeeds(event.target);
});

document.addEventListener('change', (event) => {
  if (event.target.closest('[data-collection-filter-form]')) {
    updateCollectionFilterApplyText();
  }
});

document.addEventListener('input', (event) => {
  if (event.target.closest('[data-collection-filter-form]')) {
    updatePriceRangeOutputs();
    updateCollectionFilterApplyText();
  }
});

document.addEventListener('submit', (event) => {
  const sortForm = event.target.closest('[data-collection-sort-form]');
  if (sortForm) {
    event.preventDefault();
    submitCollectionSort(sortForm, event.submitter);
    return;
  }

  const form = event.target.closest('[data-collection-filter-form]');
  if (!form) return;

  event.preventDefault();
  submitCollectionFilters(form);
});

document.addEventListener('mouseover', (event) => {
  const hoveredMainNavItem = event.target.closest('.main-nav__item, .main-nav__link');
  const navDropdown = event.target.closest('[data-nav-dropdown]');
  const menu = document.querySelector('[data-mega-menu]');

  if (hoveredMainNavItem && !event.target.closest('[data-mega-trigger-item]') && menu && window.matchMedia('(min-width: 981px)').matches) {
    menu.classList.remove('is-open');
    const activeTrigger = document.querySelector('[data-mega-trigger][aria-expanded="true"]');
    if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'false');
  }

  if (navDropdown && window.matchMedia('(min-width: 981px)').matches) {
    navDropdown.classList.add('is-open');
    const toggle = navDropdown.querySelector('[data-nav-dropdown-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  const megaTriggerItem = event.target.closest('[data-mega-trigger-item]');
  const trigger = event.target.closest('[data-mega-trigger]');
  if ((trigger || megaTriggerItem) && menu && window.matchMedia('(min-width: 981px)').matches) {
    menu.classList.add('is-open');
    const activeTrigger = megaTriggerItem ? megaTriggerItem.querySelector('[data-mega-trigger]') : trigger;
    if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'true');
  }
});

document.addEventListener('mouseout', (event) => {
  const navDropdown = event.target.closest('[data-nav-dropdown]');
  if (navDropdown && window.matchMedia('(min-width: 981px)').matches) {
    const nextTarget = event.relatedTarget;
    if (!nextTarget || !navDropdown.contains(nextTarget)) {
      navDropdown.classList.remove('is-open');
      const toggle = navDropdown.querySelector('[data-nav-dropdown-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  }

  const header = event.target.closest('.site-header');
  const nextTarget = event.relatedTarget;
  if (!header || (nextTarget && header.contains(nextTarget))) return;
  const menu = document.querySelector('[data-mega-menu]');
  if (menu && window.matchMedia('(min-width: 981px)').matches) {
    menu.classList.remove('is-open');
    const activeTrigger = document.querySelector('[data-mega-trigger][aria-expanded="true"]');
    if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'false');
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add-form]');
  if (!form || !window.fetch) return;

  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const original = button ? button.textContent : '';
  const addingText = document.documentElement.dataset.addingText || 'Aggiungo...';
  const addedText = document.documentElement.dataset.addedText || 'Aggiunto';

  try {
    if (button) {
      button.disabled = true;
      button.textContent = addingText;
    }
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Cart add failed');
    const cartResponse = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (cartResponse.ok) {
      const cart = await cartResponse.json();
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
    }
    if (button) button.textContent = addedText;
    openCartDrawer(false);
    document.dispatchEvent(new CustomEvent('closer:cart:updated'));
  } catch (error) {
    form.submit();
  } finally {
    window.setTimeout(() => {
      if (button) {
        button.disabled = false;
        button.textContent = original;
      }
    }, 1400);
  }
});

document.addEventListener('change', (event) => {
  const optionInput = event.target.closest('[data-product-option]');
  if (!optionInput) return;

  const wrapper = optionInput.closest('[data-product-form]');
  const form = optionInput.closest('form');
  if (!wrapper || !form) return;

  form.querySelectorAll(`[name="${optionInput.name}"]`).forEach((input) => {
    const label = input.closest('.product-option-value');
    if (label) label.classList.toggle('is-selected', input.checked);
  });

  const selectedOptionLabel = form.querySelector(`[data-product-option-selected="${optionInput.dataset.optionPosition}"]`);
  if (selectedOptionLabel) {
    selectedOptionLabel.textContent = optionInput.value;
  }

  let variants = [];
  try {
    variants = JSON.parse(wrapper.dataset.productVariants || '[]');
  } catch (error) {}

  const selectedOptions = [1, 2, 3].map((position) => {
    const selected = form.querySelector(`[data-option-position="${position}"]:checked`);
    return selected ? selected.value : null;
  }).filter(Boolean);

  const matchedVariant = variants.find((variant) => (
    selectedOptions.every((value, index) => variant[`option${index + 1}`] === value)
  ));

  const variantInput = form.querySelector('[data-product-variant-id]');
  const submit = form.querySelector('.product-submit');

  if (matchedVariant && variantInput) {
    variantInput.value = matchedVariant.id;
  }

  if (submit && matchedVariant) {
    submit.disabled = !matchedVariant.available;
  }
});

async function openCartDrawer(fetchCart = true) {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('cart-drawer-open');

  if (fetchCart) {
    try {
      const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (response.ok) {
        const cart = await response.json();
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
      }
    } catch (error) {}
  }
}

function closeCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('cart-drawer-open');
}

function closeMobileMenu() {
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (!mobileMenu) return;
  mobileMenu.classList.remove('is-open');
  mobileMenu.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('mobile-menu-open');
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  if (mobileMenuToggle) mobileMenuToggle.setAttribute('aria-expanded', 'false');
}

function stepHomeFeedCardMedia(control) {
  const card = control.closest('[data-feed-media-card]');
  const slides = card ? Array.from(card.querySelectorAll('[data-feed-media-image]')) : [];
  if (slides.length < 2) return;

  const activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
  const direction = control.matches('[data-feed-media-prev]') ? -1 : 1;
  const nextIndex = (activeIndex + direction + slides.length) % slides.length;

  slides.forEach((slide, index) => {
    const isActive = index === nextIndex;
    slide.hidden = !isActive;
    slide.classList.toggle('is-active', isActive);
  });
}

function updateCartCount(itemCount) {
  document.querySelectorAll('[data-cart-count]').forEach((count) => {
    count.textContent = itemCount;
    count.classList.toggle('is-empty', itemCount === 0);
  });
}

function renderCartDrawer(cart) {
  const body = document.querySelector('[data-cart-drawer-body]');
  if (!body) return;
  const root = document.documentElement.dataset;
  const emptyText = root.cartEmptyText || 'Il tuo carrello è vuoto.';
  const continueText = root.cartContinueText || 'Continua lo shopping';
  const quantityText = root.cartQuantityText || 'Quantità';

  if (!cart || cart.item_count === 0) {
    body.innerHTML = `
      <div class="cart-drawer__empty">
        <p>${escapeHtml(emptyText)}</p>
        <div class="cart-drawer__empty-icon">
          <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M6 7h12l1 14H5L6 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>
        </div>
        <button class="button button--dark" type="button" data-cart-drawer-close>${escapeHtml(continueText)}</button>
      </div>`;
    return;
  }

  const items = cart.items.map((item, index) => {
    const itemUrl = escapeHtml(safeUrl(item.url));
    const safeImageUrl = item.image ? safeUrl(item.image, '') : '';
    const imageUrl = escapeHtml(safeImageUrl);
    const quantity = Math.max(parseInt(item.quantity, 10) || 1, 1);
    const image = safeImageUrl
      ? `<img src="${imageUrl}" alt="${escapeHtml(item.product_title)}">`
      : '<div class="placeholder-art"></div>';
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<p class="cart-drawer__variant">${escapeHtml(item.variant_title)}</p>`
      : '';
    return `
      <article class="cart-drawer__item">
        <a class="cart-drawer__image" href="${itemUrl}">${image}</a>
        <div class="cart-drawer__item-info">
          <div class="cart-drawer__item-main">
            <a class="cart-drawer__item-title" href="${itemUrl}">${escapeHtml(item.product_title)}</a>
            <p class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</p>
            ${variant}
            <div class="cart-drawer__purchase-row">
              <label class="visually-hidden" for="DrawerQuantity-${index + 1}">${escapeHtml(quantityText)}: ${escapeHtml(item.product_title)}</label>
              <div class="quantity-stepper cart-drawer__quantity" data-quantity-stepper>
                <button type="button" aria-label="Diminuisci quantità" data-quantity-step="-1">−</button>
                <input id="DrawerQuantity-${index + 1}" class="quantity-input" type="number" name="updates[]" value="${quantity}" min="1">
                <button type="button" aria-label="Aumenta quantità" data-quantity-step="1">+</button>
              </div>
              <a class="cart-drawer__remove" href="/cart/change?line=${index + 1}&quantity=0" aria-label="Rimuovi ${escapeHtml(item.product_title)} dal carrello" data-cart-remove data-line="${index + 1}">Rimuovi</a>
            </div>
          </div>
        </div>
      </article>`;
  }).join('');

  body.innerHTML = `
    <form action="/cart" method="post" class="cart-drawer__form">
      <div class="cart-drawer__items">${items}</div>
      <footer class="cart-drawer__footer">
        <div class="cart-drawer__note">
          <label for="CartDrawerNote">Aggiungi una nota all'ordine</label>
          <textarea id="CartDrawerNote" name="note" rows="2" placeholder="Imposte e spese di spedizione calcolate al momento del check-out">${escapeHtml(cart.note || '')}</textarea>
        </div>
        <button class="button button--dark button--full cart-drawer__checkout" type="submit" name="checkout">
          <span>Checkout</span>
          <span aria-hidden="true">•</span>
          <strong>${formatMoney(cart.total_price)}</strong>
        </button>
      </footer>
    </form>`;
}

async function removeCartLine(trigger) {
  const line = parseInt(trigger.dataset.line, 10);
  if (!line) return;

  trigger.setAttribute('aria-disabled', 'true');
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ line, quantity: 0 })
    });
    if (!response.ok) throw new Error('Cart remove failed');

    const cart = await response.json();
    updateCartCount(cart.item_count);
    renderCartDrawer(cart);
    document.dispatchEvent(new CustomEvent('closer:cart:updated'));
  } catch (error) {
    window.location.href = trigger.href;
  }
}

function formatMoney(cents) {
  const currency = document.documentElement.dataset.cartCurrency || (window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR');
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', { style: 'currency', currency }).format(cents / 100);
  } catch (error) {
    return `€${(cents / 100).toFixed(2).replace('.', ',')}`;
  }
}

document.addEventListener('input', debounce(async (event) => {
  const input = event.target.closest('[data-predictive-search-input]');
  if (!input) return;

  const results = document.querySelector('[data-predictive-search-results]');
  const query = input.value.trim();
  if (!results) return;

  if (query.length < 2) {
    results.innerHTML = '<p class="search-results__hint">Inizia a scrivere per cercare nel catalogo.</p>';
    return;
  }

  try {
    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last`;
    const response = await fetch(url, { headers: { 'Accept': 'application/json' } });
    if (!response.ok) throw new Error('Predictive search failed');
    const data = await response.json();
    const products = data.resources && data.resources.results ? data.resources.results.products : [];

    if (!products.length) {
      results.innerHTML = '<p class="search-results__empty">Nessun prodotto trovato.</p>';
      return;
    }

    results.innerHTML = `<div class="search-results__grid">${products.map((product) => {
      const imageUrl = typeof product.image === 'string' ? product.image : product.image && product.image.url;
      const imageAlt = product.image && product.image.alt ? product.image.alt : product.title;
      const safeImageUrl = imageUrl ? safeUrl(imageUrl, '') : '';
      const image = safeImageUrl ? `<img src="${escapeHtml(safeImageUrl)}" alt="${escapeHtml(imageAlt)}">` : '<span class="search-result-card__placeholder"></span>';
      const price = product.price || '';
      return `<a class="search-result-card" href="${escapeHtml(safeUrl(product.url))}">${image}<span><strong>${escapeHtml(product.title)}</strong><span>${escapeHtml(price)}</span></span></a>`;
    }).join('')}</div>`;
  } catch (error) {
    results.innerHTML = '<p class="search-results__empty">Premi invio per completare la ricerca.</p>';
  }
}, 220));

document.addEventListener('click', (event) => {
  const revealMore = event.target.closest('[data-home-feed-reveal-more]');
  if (revealMore) {
    revealHomeProductFeedItems(revealMore);
    return;
  }

  const loadMore = event.target.closest('[data-home-feed-load-more]');
  if (loadMore && window.fetch && window.DOMParser) {
    event.preventDefault();
    loadMoreHomeProductFeed(loadMore);
    return;
  }

  const tab = event.target.closest('[data-carousel-tab]');
  if (tab) {
    const section = tab.closest('[data-featured-carousel]');
    if (!section) return;
    section.querySelectorAll('[data-carousel-tab]').forEach((button) => button.classList.remove('is-active'));
    section.querySelectorAll('[data-carousel-panel]').forEach((panel) => panel.classList.remove('is-active'));
    tab.classList.add('is-active');
    const panel = section.querySelector(`[data-carousel-panel="${tab.dataset.carouselTab}"]`);
    if (panel) panel.classList.add('is-active');
    return;
  }

  const next = event.target.closest('[data-carousel-next]');
  const prev = event.target.closest('[data-carousel-prev]');
  if (next || prev) {
    const section = event.target.closest('[data-featured-carousel]');
    const track = section && section.querySelector('.carousel-panel.is-active [data-carousel-track]');
    if (!track) return;
    const distance = track.clientWidth * 0.82;
    track.scrollBy({ left: next ? distance : -distance, behavior: 'smooth' });
  }
});

document.querySelectorAll('[data-carousel-track]').forEach((track) => {
  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;

  track.addEventListener('pointerdown', (event) => {
    isDown = true;
    startX = event.pageX;
    scrollLeft = track.scrollLeft;
    track.setPointerCapture(event.pointerId);
  });

  track.addEventListener('pointermove', (event) => {
    if (!isDown) return;
    track.scrollLeft = scrollLeft - (event.pageX - startX);
  });

  track.addEventListener('pointerup', () => { isDown = false; });
  track.addEventListener('pointercancel', () => { isDown = false; });
});

function revealHomeProductFeedItems(button) {
  const section = button.closest('[data-home-product-feed]');
  const hiddenItems = section ? Array.from(section.querySelectorAll('[data-home-feed-reveal-item].is-hidden')) : [];
  const pageSize = Math.max(parseInt(button.dataset.pageSize, 10) || 8, 1);

  hiddenItems.slice(0, pageSize).forEach((item) => {
    item.classList.remove('is-hidden');
    item.removeAttribute('data-home-feed-reveal-item');
  });

  const remainingItems = section ? section.querySelectorAll('[data-home-feed-reveal-item].is-hidden') : [];
  if (!remainingItems.length) {
    const pagination = button.closest('[data-home-product-feed-pagination]');
    if (pagination) pagination.remove();
  }
}

function initRandomHomeProductFeeds(scope = document) {
  scope.querySelectorAll('[data-home-feed-random]').forEach((grid) => {
    if (grid.dataset.randomized === 'true') return;

    const items = Array.from(grid.children);
    for (let index = items.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [items[index], items[randomIndex]] = [items[randomIndex], items[index]];
    }
    items.forEach((item) => grid.appendChild(item));
    grid.dataset.randomized = 'true';
  });
}

function openCollectionFilters(drawer, trigger) {
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('collection-filter-open');
  if (trigger) trigger.setAttribute('aria-expanded', 'true');
}

function closeCollectionFilters(drawer) {
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('collection-filter-open');
  const trigger = document.querySelector('[data-collection-filter-open]');
  if (trigger) trigger.setAttribute('aria-expanded', 'false');
}

function setCollectionView(columns, options = {}) {
  const allowedColumns = ['3', '4', '5'];
  const selectedColumns = allowedColumns.includes(String(columns)) ? String(columns) : '3';
  const grid = document.querySelector('[data-collection-grid]');
  const buttons = document.querySelectorAll('[data-collection-view]');
  const page = document.querySelector('[data-collection-page]');

  if (!grid || !buttons.length) return;

  grid.style.setProperty('--collection-columns', selectedColumns);
  updateCollectionViewInputs(selectedColumns);
  buttons.forEach((button) => {
    const active = button.dataset.collectionView === selectedColumns;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
  });

  if (options.persist !== false && window.localStorage) {
    window.localStorage.setItem('closerCollectionView', selectedColumns);
  }

  if (options.load) {
    loadCollectionView(selectedColumns, page);
  }
}

function updateCollectionViewInputs(selectedColumns) {
  document.querySelectorAll('input[name="view"]').forEach((input) => {
    input.value = selectedColumns;
  });
}

function getCollectionViewUrl(selectedColumns) {
  const nextUrl = new URL(window.location.href);
  nextUrl.searchParams.set('view', selectedColumns);
  nextUrl.searchParams.delete('page');
  return nextUrl;
}

async function loadCollectionView(selectedColumns, page) {
  if (!window.fetch || !page) {
    window.location.href = getCollectionViewUrl(selectedColumns).toString();
    return;
  }

  const nextUrl = getCollectionViewUrl(selectedColumns);
  page.setAttribute('aria-busy', 'true');

  try {
    const response = await fetch(nextUrl.toString(), { headers: { 'Accept': 'text/html' } });
    if (!response.ok) throw new Error('Collection view failed');

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextGrid = doc.querySelector('[data-collection-grid]');
    const currentGrid = document.querySelector('[data-collection-grid]');
    const nextPagination = doc.querySelector('[data-collection-pagination]');
    const currentPagination = document.querySelector('[data-collection-pagination]');

    if (!nextGrid || !currentGrid) throw new Error('Collection grid not found');

    currentGrid.replaceWith(document.importNode(nextGrid, true));

    if (nextPagination && currentPagination) {
      currentPagination.replaceWith(document.importNode(nextPagination, true));
    } else if (nextPagination && !currentPagination) {
      document.querySelector('[data-collection-grid]').after(document.importNode(nextPagination, true));
    } else if (!nextPagination && currentPagination) {
      currentPagination.remove();
    }

    window.history.pushState({}, '', nextUrl.toString());
    setCollectionView(selectedColumns, { persist: false, load: false });
    updateCollectionVendorTitle();
    applyCollectionOptionFilters();
  } catch (error) {
    window.location.href = nextUrl.toString();
  } finally {
    page.removeAttribute('aria-busy');
  }
}

function updateCollectionFilterApplyText() {
  const form = document.querySelector('[data-collection-filter-form]');
  const button = form && form.querySelector('[data-collection-filter-apply]');
  if (!form || !button) return;

  const checkedFilters = form.querySelectorAll('input[type="checkbox"]:checked').length;
  const priceChanged = Array.from(form.querySelectorAll('[data-price-range]')).some((range) => (
    range.value !== range.dataset.priceRangeDefault
  ));
  const filterCount = checkedFilters + (priceChanged ? 1 : 0);

  button.textContent = filterCount > 0 ? `Applica ${filterCount} ${filterCount === 1 ? 'Filtro' : 'Filtri'}` : 'Applica';
}

function syncCollectionFilterInputsFromUrl() {
  const form = document.querySelector('[data-collection-filter-form]');
  if (!form) return;

  const params = new URLSearchParams(window.location.search);
  const selectedByName = new Map();

  params.forEach((value, key) => {
    if (!key.startsWith('filter.') || value === '') return;

    const values = selectedByName.get(key) || [];
    values.push(normalizeCollectionFilterValue(value));
    selectedByName.set(key, values);
  });

  form.querySelectorAll('input[type="checkbox"][name^="filter."]').forEach((input) => {
    const selectedValues = selectedByName.get(input.name);
    if (!selectedValues || input.value === '') return;

    input.checked = selectedValues.includes(normalizeCollectionFilterValue(input.value));
  });

  form.querySelectorAll('[data-price-range]').forEach((range) => {
    const selectedValue = params.get(range.name);
    if (selectedValue != null && selectedValue !== '') {
      range.value = selectedValue;
    }
  });
}

function submitCollectionFilters(form) {
  const nextUrl = new URL(form.action || window.location.href, window.location.origin);
  const currentParams = new URLSearchParams(window.location.search);
  const nextParams = new URLSearchParams();
  const representedNames = new Set();
  const legacyCollectionFilters = new Set(['filter.closer.category', 'filter.closer.color']);

  form.querySelectorAll('input[name], select[name], textarea[name], button[name]').forEach((field) => {
    representedNames.add(field.name);
  });

  currentParams.forEach((value, key) => {
    if (key === 'page' || representedNames.has(key) || legacyCollectionFilters.has(key)) return;
    nextParams.append(key, value);
  });

  const formData = new FormData(form);
  form.querySelectorAll('[data-price-range]').forEach((range) => {
    if (range.value === range.dataset.priceRangeDefault) {
      formData.delete(range.name);
    }
  });

  formData.forEach((value, key) => {
    if (value !== '') nextParams.append(key, value);
  });

  nextUrl.search = nextParams.toString();
  window.location.href = nextUrl.toString();
}

function updatePriceRangeOutputs() {
  document.querySelectorAll('[data-price-range]').forEach((range) => {
    const output = range.dataset.priceRangeOutput ? document.getElementById(range.dataset.priceRangeOutput) : null;
    if (!output) return;

    const currency = output.textContent.trim().match(/[€$£¥]/);
    output.textContent = `Fino a ${currency ? currency[0] : '€'}${Number(range.value).toLocaleString('it-IT')}`;
  });
}

function normalizeCollectionFilterValue(value) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function getSelectedCollectionSizeFilters() {
  return getSelectedCollectionOptionFilters(['taglia', 'taglie', 'size', 'misura', 'misure', 'numero', 'numeri', 'number']);
}

function getSelectedCollectionColorFilters() {
  return getSelectedCollectionOptionFilters(['colore', 'color', 'colour']);
}

function getSelectedCollectionCategoryFilters() {
  return getSelectedCollectionOptionFilters(
    ['categoria', 'category', 'categorie', 'tipologia', 'product-type'],
    ['filter.p.product_type', 'filter.p.category']
  );
}

function getSelectedCollectionVendorFilters() {
  return getSelectedCollectionParamFilters(['filter.p.vendor']);
}

function getSelectedCollectionAvailabilityFilter() {
  const params = new URLSearchParams(window.location.search);
  return params.getAll('filter.v.availability').includes('1');
}

function getSelectedCollectionPriceFilter() {
  const params = new URLSearchParams(window.location.search);
  const min = Number(params.get('filter.v.price.gte') || params.get('filter.p.price.gte') || 0);
  const max = Number(params.get('filter.v.price.lte') || params.get('filter.p.price.lte') || 0);

  return {
    min: Number.isFinite(min) && min > 0 ? Math.round(min * 100) : 0,
    max: Number.isFinite(max) && max > 0 ? Math.round(max * 100) : 0
  };
}

function hasSelectedCollectionClientSideFilters() {
  const params = new URLSearchParams(window.location.search);
  return Array.from(params.keys()).some((key) => key.startsWith('filter.'));
}

function getSelectedCollectionOptionFilters(optionNames, customKeys = []) {
  const params = new URLSearchParams(window.location.search);
  const selectedValues = [];

  params.forEach((value, key) => {
    const normalizedKey = key.replace(/-/g, '.').toLowerCase();
    const isCustomFilter = customKeys.includes(normalizedKey);
    const isTargetFilter = optionNames.some((name) => (
      normalizedKey === `filter.v.option.${name}` || normalizedKey.endsWith(`.option.${name}`)
    ));

    if (!isCustomFilter && !isTargetFilter) return;

    const normalizedValue = normalizeCollectionFilterValue(value);
    if (normalizedValue && !selectedValues.includes(normalizedValue)) {
      selectedValues.push(normalizedValue);
    }
  });

  return selectedValues;
}

function getSelectedCollectionParamFilters(paramNames) {
  const params = new URLSearchParams(window.location.search);
  const selectedValues = [];

  paramNames.forEach((name) => {
    params.getAll(name).forEach((value) => {
      const normalizedValue = normalizeCollectionFilterValue(value);
      if (normalizedValue && !selectedValues.includes(normalizedValue)) {
        selectedValues.push(normalizedValue);
      }
    });
  });

  return selectedValues;
}

function getCollectionClientFilterPage() {
  const params = new URLSearchParams(window.location.search);
  const page = Number(params.get('filter_page')) || 1;
  return page > 0 ? page : 1;
}

function buildCollectionClientFilterUrl(page) {
  const nextUrl = new URL(window.location.href);

  if (page > 1) {
    nextUrl.searchParams.set('filter_page', String(page));
  } else {
    nextUrl.searchParams.delete('filter_page');
  }

  nextUrl.searchParams.delete('page');
  return nextUrl.toString();
}

function renderCollectionClientPagination(totalProducts, pageSize, currentPage) {
  const existingPagination = document.querySelector('[data-collection-client-pagination]');
  if (existingPagination) existingPagination.remove();

  const serverPagination = document.querySelector('[data-collection-pagination]');
  if (serverPagination) serverPagination.hidden = true;

  const grid = document.querySelector('[data-collection-grid]');
  const totalPages = Math.ceil(totalProducts / pageSize);
  if (!grid || totalPages <= 1) return;

  const pagination = document.createElement('nav');
  pagination.className = 'pagination collection-pagination';
  pagination.setAttribute('aria-label', 'Paginazione');
  pagination.setAttribute('data-collection-client-pagination', '');

  const list = document.createElement('div');
  list.className = 'pagination__list';

  for (let page = 1; page <= totalPages; page += 1) {
    const link = document.createElement(page === currentPage ? 'span' : 'a');
    link.textContent = String(page);
    link.className = page === currentPage ? 'page current' : 'page';

    if (page !== currentPage) {
      link.href = buildCollectionClientFilterUrl(page);
    }

    list.appendChild(link);
  }

  pagination.appendChild(list);
  grid.after(pagination);
}

async function loadCollectionFilterSourcePages(grid) {
  if (!grid || grid.dataset.clientFilterLoaded === 'true') return;

  grid.dataset.clientFilterLoaded = 'true';
  const loadingNode = grid.querySelector('[data-collection-filter-loading]');
  const existingHrefs = new Set();

  grid.querySelectorAll('[data-product-card]').forEach((card) => {
    card.remove();
  });

  const fetchSourcePage = async (page) => {
    const sourceUrl = new URL(window.location.href);
    sourceUrl.searchParams.delete('filter_page');
    sourceUrl.searchParams.set('view', 'filter-source');
    sourceUrl.searchParams.set('page', String(page));

    const response = await fetch(sourceUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!response.ok) return null;

    const html = await response.text();
    return new DOMParser().parseFromString(html, 'text/html');
  };

  const firstDoc = await fetchSourcePage(1);
  if (!firstDoc) return;

  const appendSourceCards = (doc) => {
    const nextCards = Array.from(doc.querySelectorAll('[data-collection-filter-source] [data-product-card]'));

    nextCards.forEach((card) => {
      const productLink = card.querySelector('a[href*="/products/"]');
      const productPath = productLink ? new URL(productLink.href, window.location.origin).pathname : '';

      if (productPath && existingHrefs.has(productPath)) return;
      if (productPath) existingHrefs.add(productPath);
      grid.appendChild(document.importNode(card, true));
    });
  };

  appendSourceCards(firstDoc);
  if (loadingNode) grid.prepend(loadingNode);

  const sourceNode = firstDoc.querySelector('[data-collection-filter-source]');
  const pagination = firstDoc.querySelector('[data-collection-filter-source-pagination]');
  const sourcePages = Number(sourceNode && sourceNode.dataset.filterSourcePages) || 1;
  const pageNumbers = pagination
    ? Array.from(pagination.querySelectorAll('a[href*="page="]'))
      .map((link) => Number(new URL(link.href, window.location.origin).searchParams.get('page')))
      .filter((page) => Number.isFinite(page) && page > 1)
    : [];
  const maxPage = Math.min(50, Math.max(sourcePages, ...pageNumbers, 1));
  const remainingPages = [];

  for (let page = 2; page <= maxPage; page += 1) {
    remainingPages.push(page);
  }

  const docs = await Promise.all(remainingPages.map((page) => fetchSourcePage(page)));
  docs.filter(Boolean).forEach((doc) => {
    appendSourceCards(doc);
  });
}

async function applyCollectionOptionFilters() {
  const grid = document.querySelector('[data-collection-grid]');
  if (!grid) return;

  const selectedCategories = getSelectedCollectionCategoryFilters();
  const selectedSizes = getSelectedCollectionSizeFilters();
  const selectedColors = getSelectedCollectionColorFilters();
  const selectedVendors = getSelectedCollectionVendorFilters();
  const excludeSoldOut = getSelectedCollectionAvailabilityFilter();
  const selectedPrice = getSelectedCollectionPriceFilter();
  const pagination = document.querySelector('[data-collection-pagination]');
  const hasClientSideFilters = hasSelectedCollectionClientSideFilters();
  const productsPerPage = hasClientSideFilters ? 16 : (Number(grid.dataset.clientPageSize || grid.dataset.productsPerPage) || 24);
  const currentPage = getCollectionClientFilterPage();
  const emptyMessageId = 'CollectionOptionFilterEmpty';
  let emptyMessage = document.getElementById(emptyMessageId);

  if (pagination) {
    pagination.hidden = false;
  }

  if (!hasClientSideFilters) {
    if (emptyMessage) emptyMessage.remove();
    grid.setAttribute('data-client-filter-ready', '');
    return;
  }

  try {
    await loadCollectionFilterSourcePages(grid);
  } catch (error) {
    grid.setAttribute('data-client-filter-ready', '');
    return;
  }

  const cards = Array.from(grid.querySelectorAll('[data-product-card]'));

  if (!selectedCategories.length && !selectedSizes.length && !selectedColors.length && !selectedVendors.length && !excludeSoldOut && !selectedPrice.min && !selectedPrice.max) {
    cards.forEach((card) => {
      card.hidden = false;
    });
    if (emptyMessage) emptyMessage.remove();
    return;
  }

  let visibleCount = 0;
  let matchedIndex = 0;
  const pageStart = (currentPage - 1) * productsPerPage;
  const pageEnd = pageStart + productsPerPage;

  cards.forEach((card) => {
    const availableCategories = card.dataset.filterCategories || '';
    const availableSizes = card.dataset.filterSizes || '';
    const availableColors = card.dataset.filterColors || '';
    const availableVendor = card.dataset.filterVendor || '';
    const isAvailable = card.dataset.filterAvailable === '1';
    const price = Number(card.dataset.filterPrice) || 0;
    const matchesCategory = !selectedCategories.length || selectedCategories.some((category) => availableCategories.includes(`|${category}|`));
    const matchesSize = !selectedSizes.length || selectedSizes.some((size) => availableSizes.includes(`|${size}|`));
    const matchesColor = !selectedColors.length || selectedColors.some((color) => availableColors.includes(`|${color}|`));
    const matchesVendor = !selectedVendors.length || selectedVendors.includes(availableVendor);
    const matchesAvailability = !excludeSoldOut || isAvailable;
    const matchesMinPrice = !selectedPrice.min || price >= selectedPrice.min;
    const matchesMaxPrice = !selectedPrice.max || price <= selectedPrice.max;
    const isMatch = matchesCategory && matchesSize && matchesColor && matchesVendor && matchesAvailability && matchesMinPrice && matchesMaxPrice;
    const isVisible = isMatch && matchedIndex >= pageStart && matchedIndex < pageEnd;

    card.hidden = !isVisible;
    if (isMatch) {
      matchedIndex += 1;
      visibleCount += 1;
    }
  });

  if (!visibleCount) {
    if (!emptyMessage) {
      emptyMessage = document.createElement('p');
      emptyMessage.id = emptyMessageId;
      emptyMessage.className = 'collection-products__empty';
      emptyMessage.textContent = 'Nessun prodotto trovato con questi filtri.';
      grid.appendChild(emptyMessage);
    }
  } else if (emptyMessage) {
    emptyMessage.remove();
  }

  const countNode = document.querySelector('[data-collection-count]');
  if (countNode) {
    countNode.textContent = `${visibleCount} ${visibleCount === 1 ? 'prodotto trovato' : 'prodotti trovati'}`;
  }

  if (pagination) {
    pagination.hidden = true;
  }

  renderCollectionClientPagination(visibleCount, productsPerPage, currentPage);
  grid.setAttribute('data-client-filter-ready', '');
}

function updateCollectionVendorTitle() {
  const params = new URLSearchParams(window.location.search);
  const vendor = params.get('filter.p.vendor') || (window.location.pathname.includes('/collections/vendors') ? params.get('q') : '');
  if (!vendor) return;

  const titleNode = document.querySelector('[data-collection-title]');
  const baseTitle = titleNode ? titleNode.textContent.trim() : '';
  const title = window.location.pathname.includes('/collections/vendors')
    ? `Tutti i prodotti di ${vendor}`
    : `${baseTitle && !baseTitle.includes(' di ') ? baseTitle : 'Prodotti'} di ${vendor}`;
  const breadcrumbNode = document.querySelector('[data-collection-breadcrumb-current]');
  const countNode = document.querySelector('[data-collection-count]');

  if (titleNode) titleNode.textContent = title;
  if (breadcrumbNode) breadcrumbNode.textContent = title;
  if (countNode && countNode.textContent.trim()) countNode.textContent = countNode.textContent.trim().toLowerCase();
}

function submitCollectionSort(form, eventSubmitter) {
  const submitter = eventSubmitter && eventSubmitter.matches('button[name="sort_by"]')
    ? eventSubmitter
    : form.querySelector('button[name="sort_by"].is-active');
  const sortValue = submitter ? submitter.value : '';
  const nextUrl = new URL(window.location.href);

  if (sortValue) {
    nextUrl.searchParams.set('sort_by', sortValue);
  } else {
    nextUrl.searchParams.delete('sort_by');
  }
  const viewInput = form.querySelector('input[name="view"]');
  if (viewInput && viewInput.value) nextUrl.searchParams.set('view', viewInput.value);
  nextUrl.searchParams.delete('page');

  window.location.href = nextUrl.toString();
}

function redirectLegacyVendorFilter() {
  const params = new URLSearchParams(window.location.search);
  const vendor = params.get('filter.p.vendor');
  if (!vendor || window.location.pathname.includes('/collections/vendors')) return;
  if (window.location.pathname !== '/collections/all') return;

  const nextUrl = new URL('/collections/vendors', window.location.origin);
  nextUrl.searchParams.set('q', vendor);
  const sortBy = params.get('sort_by');
  if (sortBy) nextUrl.searchParams.set('sort_by', sortBy);
  window.location.replace(nextUrl.toString());
}

async function loadMoreHomeProductFeed(button) {
  const section = button.closest('[data-home-product-feed]');
  const grid = section && section.querySelector('[data-home-product-feed-grid]');
  const pagination = section && section.querySelector('[data-home-product-feed-pagination]');
  const nextUrl = button.dataset.nextUrl || button.getAttribute('href');
  const originalText = button.textContent;
  const loadingText = button.dataset.loadingText || originalText;

  if (!section || !grid || !pagination || !nextUrl) {
    window.location.href = button.getAttribute('href');
    return;
  }

  try {
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    button.textContent = loadingText;

    const response = await fetch(nextUrl, { headers: { 'Accept': 'text/html' } });
    if (!response.ok) throw new Error('Product feed pagination failed');

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const sectionId = section.dataset.sectionId;
    const nextSection = Array.from(doc.querySelectorAll('[data-home-product-feed]')).find((candidate) => (
      !sectionId || candidate.dataset.sectionId === sectionId
    ));
    const nextGrid = nextSection && nextSection.querySelector('[data-home-product-feed-grid]');
    const nextPagination = nextSection && nextSection.querySelector('[data-home-product-feed-pagination]');

    if (!nextGrid) throw new Error('Product feed grid not found');

    nextGrid.querySelectorAll('.home-feed-card').forEach((card) => {
      grid.appendChild(document.importNode(card, true));
    });

    if (nextPagination) {
      pagination.replaceWith(document.importNode(nextPagination, true));
    } else {
      pagination.remove();
    }
  } catch (error) {
    window.location.href = nextUrl;
  } finally {
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    button.textContent = originalText;
  }
}

function debounce(fn, wait) {
  let timeout;
  return (...args) => {
    window.clearTimeout(timeout);
    timeout = window.setTimeout(() => fn(...args), wait);
  };
}

function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  })[char]);
}

function safeUrl(value, fallback = '#') {
  const rawValue = String(value || '').trim();
  if (!rawValue) return fallback;

  try {
    const url = new URL(rawValue, window.location.origin);
    if (!['http:', 'https:'].includes(url.protocol)) return fallback;
    if (rawValue.startsWith('/') && !rawValue.startsWith('//')) {
      return `${url.pathname}${url.search}${url.hash}`;
    }
    return url.href;
  } catch (error) {
    return fallback;
  }
}

function initHeaderAnnouncementSliders(scope = document) {
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  scope.querySelectorAll('[data-top-announcement-bar] .header-info-bar__slider').forEach((slider) => {
    if (slider.dataset.sliderInitialized === 'true') return;

    const slides = Array.from(slider.querySelectorAll('.header-info-bar__slide'));
    if (!slides.length) return;

    slider.dataset.sliderInitialized = 'true';
    slides.forEach((slide, index) => slide.classList.toggle('is-active', index === 0));

    if (reduceMotion || slides.length === 1) return;

    const bar = slider.closest('[data-top-announcement-bar]');
    const cycleSeconds = Number.parseFloat(bar && bar.dataset.cycle);
    const interval = Number.isFinite(cycleSeconds) && cycleSeconds > 0 ? cycleSeconds * 1000 : 8000;
    slider.style.setProperty('--bar-slide-interval', `${interval}ms`);
    let activeIndex = 0;

    window.setInterval(() => {
      slides[activeIndex].classList.remove('is-active');
      activeIndex = (activeIndex + 1) % slides.length;
      slides[activeIndex].classList.add('is-active');
    }, interval);
  });
}
